export default __webpack_public_path__ + "1d6340ff34328f136fd09ac8eac30eb3.png";